import React from 'react';
import { ListPageScaffold } from '../components/common/list-page';
import { SystemParameters } from '../components/system-parameters/SystemParameters';

const SystemParametersPage: React.FC = () => {
  const handleParameterUpdate = () => {
    // TODO: Implement parameter update logic
  };

  return (
    <ListPageScaffold>
      <SystemParameters onParameterUpdate={handleParameterUpdate} />
    </ListPageScaffold>
  );
};

export default SystemParametersPage;
